const toggleAssigned = function() {
  $('form.registration.where .assigned').toggle($('form.registration.where input:radio:checked').val() == 'false')
}

$(document).on('click', 'form.registration.where input:radio', toggleAssigned)
$(toggleAssigned)
